import Touchable from '@components/Touchable'
import React, { FC, ReactNode } from 'react'
import { ButtonProps, CircularProgress, Button as MUIButton, styled } from '@mui/material'

interface Props extends ButtonProps {
  loading?: boolean
}

const Button: FC<Props> = ({ children, loading, fullWidth, ...buttonProps }) => {
  return (
    <Touchable style={fullWidth ? { display: 'flex', flex: 1 } : undefined}>
      <MUIButton
        startIcon={loading && <CircularProgress size={20} thickness={5} />}
        disableRipple
        fullWidth={fullWidth}
        {...buttonProps}
      >
        {children}
      </MUIButton>
    </Touchable>
  )
}

export default Button
